export default [

    {
        path: '',
        name: 'box',
        redirect: { name: 'box-home' },
    },

    {
        path: 'home',
        name: 'box-home',
        component: () => import('@/aplicacao/modulos/box/_Home'),
        meta: { autenticacao: true, permissao: 'ROLE_BOX' },
    },

    {
        path: 'novo',
        name: 'box-novo',
        component: () => import('@/aplicacao/modulos/box/formulario/Novo'),
        meta: { autenticacao: true, permissao: 'ROLE_BOX_SOLICITAR' },
    },

    {
        path: 'rascunho/:id',
        name: 'box-rascunho',
        component: () => import('@/aplicacao/modulos/box/formulario/Rascunho'),
        meta: { autenticacao: true, permissao: 'ROLE_BOX_SOLICITAR' },
    },

    {
        path: 'alterar/:id',
        name: 'box-alteracao',
        component: () => import('@/aplicacao/modulos/box/formulario/Alteracao'),
        meta: { autenticacao: true, permissao: 'ROLE_BOX' },
    },

    {
        path: 'formulario/:id/sucesso',
        name: 'box-sucesso',
        component: () => import('@/aplicacao/modulos/box/formulario/Sucesso'),
        meta: { autenticacao: true, permissao: 'ROLE_BOX_SOLICITAR' },
    },

    {
        path: 'historico',
        name: 'box-historico',
        component: () => import('@/aplicacao/modulos/box/Historico'),
        meta: { autenticacao: true, permissao: 'ROLE_BOX' },
    },

    {
        path: 'pendencias',
        name: 'box-pendencias',
        component: () => import('@/aplicacao/modulos/box/Pendencias'),
        meta: { autenticacao: true, permissao: 'ROLE_BOX_PENDENCIAS' },
    },

    {
        path: 'rascunhos',
        name: 'box-rascunhos',
        component: () => import('@/aplicacao/modulos/box/Rascunhos'),
        meta: { autenticacao: true, permissao: 'ROLE_BOX_SOLICITAR' },
    },

    {
        path: ':id',
        name: 'box-fluxo',
        component: () => import('@/aplicacao/modulos/box/fluxo/Fluxo'),
        meta: { autenticacao: true, permissao: 'ROLE_BOX' },
    },

    {
        path: 'relatorios/geral',
        name: 'box-relatorios-geral',
        component: () => import('@/aplicacao/modulos/box/relatorios/Geral'),
        meta: { autenticacao: true, permissao: 'ROLE_BOX_RELATORIO_GERAL' },
    },

    {
        path: 'relatorios/ranking-sku',
        name: 'box-relatorios-ranking-sku',
        component: () => import('@/aplicacao/modulos/box/relatorios/RankingSku'),
        meta: { autenticacao: true, permissao: 'ROLE_BOX_RELATORIO_RANKING_SKU' },
    },

]
